import {
  GridActionsColDef,
  GridColDef,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid-premium';
import {
  dateFilterOperators,
  filterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import toast from 'shared/utils/toast';
import { logService } from '../api/log.service';
import { MODELS_MAPS } from '../config/modelsMap';
import { baseCell } from 'components/cells/BaseCell';
import { ConfirmationGridRestoreDialog } from 'components/ui/feedback';
import { SectionHeader } from 'components/ui/typography';

export const useDeletedVersionsColumns = (): GridColDef[] => {
  const { t } = useTranslation();
  const actionsColumn: GridActionsColDef = {
    field: 'actions',
    type: 'actions',
    getActions: (params: GridRowParams) => {
      return [
        <ConfirmationGridRestoreDialog
          key={1}
          onConfirm={async () => {
            await logService.restoreDeletedObject(params.row.id);
            toast.success('Ripristino eseguito');
          }}
        />
      ];
    }
  };
  const columns: GridColDef[] = [
    {
      field: 'object_id',
      headerName: t(`global.object`),
      width: 100,
      renderCell: (params) => {
        return (
          <Link
            to={`/tenant/versions/${params.row.model_name}/${params.row.object_id}`}
            style={{ textDecoration: 'none', color: '#1976d2' }}>
            <SectionHeader title={params.row.object_id} />
          </Link>
        );
      }
    },
    {
      field: 'object_value',
      headerName: t(`global.value`),
      filterOperators,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'model_name',
      headerName: t(`global.model`),
      type: 'singleSelect',
      valueOptions: Object.entries(MODELS_MAPS).map(([value, meta]) => ({
        value,
        label: meta?.label || value
      })),
      filterOperators: singleSelectFilterOperators,
      width: 200,
      renderCell: (params) => {
        const modelKey = params.value;
        return MODELS_MAPS[modelKey]?.label || modelKey; // fallback se non trova la label
      }
    },
    {
      field: 'timestamp',
      headerName: t(`global.date`),
      filterOperators: dateFilterOperators,
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
    {
      field: 'actor_name',
      headerName: t(`global.user`),
      filterOperators,
      width: 200,
      renderCell: (params) => {
        const value = params.value;
        return value == null ? 'SYSTEM' : baseCell(params);
      }
    },
    actionsColumn
  ];
  return columns;
};
